import React from 'react'
import type { GiftDef } from '../../hooks/useGifts'

type GiftSheetProps = {
  visible: boolean
  onClose: () => void
  creatorName?: string
  avatarUrl?: string
  catalog: GiftDef[]
  onSend: (args: { gift: GiftDef }) => void
}

export default function GiftSheet({ visible, onClose, creatorName, avatarUrl, catalog, onSend }: GiftSheetProps) {
  if (!visible) return null
  return (
    <div className="fixed inset-0 z-40 flex items-end lg:items-center justify-center">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      {/* Compact, solid container (no transparency) */}
      <div className="relative w-[92%] sm:w-[80%] max-w-md lg:max-w-lg mx-auto rounded-t-2xl lg:rounded-2xl bg-neutral-900 border border-white/10 p-3 lg:p-5 shadow-2xl max-h-[60vh] overflow-hidden">
        <div className="flex items-center gap-3 mb-3 border-b border-white/10 pb-2">
          {avatarUrl ? (
            <img src={avatarUrl} className="h-10 w-10 rounded-full border border-white/20" />
          ) : (
            <div className="h-10 w-10 rounded-full bg-white/10" />
          )}
          <div className="font-semibold truncate">Send a gift{creatorName ? ` to ${creatorName}` : ''}</div>
          <button onClick={onClose} className="ml-auto text-white/80 hover:text-white">✕</button>
        </div>
        <div className="overflow-y-auto max-h-[50vh] pr-1 chat-scroll">
          <div className="grid grid-cols-4 sm:grid-cols-5 gap-2.5">
            {catalog.map((g) => (
              <button
                key={g.id}
                onClick={() => onSend({ gift: g })}
                className="rounded-xl border border-white/10 bg-neutral-800 hover:bg-neutral-700 p-2.5 flex flex-col items-center text-center"
              >
                <div className="text-xl">{g.emoji}</div>
                <div className="text-xs mt-1 font-semibold truncate w-full">{g.name}</div>
                <div className="text-[10px] text-white/70">{g.amountLabel}</div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
